/**
 * Phase 1 — onboarding bắt buộc (cấu trúc tổ chức).
 * Trong 6 bước này, `BUSINESS`, `STAFF`, `PRODUCTS`, `INVOICE` được phép
 * skip theo wireframe auth; `STORE` và `PAYMENT` là lõi vận hành.
 */
export let OnboardingPhase1Step = /*#__PURE__*/function (OnboardingPhase1Step) {
  OnboardingPhase1Step["BUSINESS"] = "business";
  OnboardingPhase1Step["STORE"] = "store";
  OnboardingPhase1Step["STAFF"] = "staff";
  OnboardingPhase1Step["PRODUCTS"] = "products";
  OnboardingPhase1Step["PAYMENT"] = "payment";
  OnboardingPhase1Step["INVOICE"] = "invoice";
  return OnboardingPhase1Step;
}({});

/**
 * Phase 2 — checklist ready-to-sell trên dashboard.
 * Mọi bước đều skip được.
 */
export let OnboardingPhase2Step = /*#__PURE__*/function (OnboardingPhase2Step) {
  OnboardingPhase2Step["BRANDING"] = "branding";
  OnboardingPhase2Step["CATALOG"] = "catalog";
  OnboardingPhase2Step["PLUGIN"] = "plugin";
  OnboardingPhase2Step["HARDWARE"] = "hardware";
  OnboardingPhase2Step["DEMO"] = "demo";
  return OnboardingPhase2Step;
}({});
export const ONBOARDING_PHASE_1_SKIPPABLE_STEPS = [OnboardingPhase1Step.BUSINESS, OnboardingPhase1Step.STAFF, OnboardingPhase1Step.PRODUCTS, OnboardingPhase1Step.INVOICE];

/** Tổng số bước, derive từ enum. */
export const ONBOARDING_PHASE_1_TOTAL_STEPS = Object.values(OnboardingPhase1Step).length;
export const ONBOARDING_PHASE_2_TOTAL_STEPS = Object.values(OnboardingPhase2Step).length;
//# sourceMappingURL=onboarding.enum.js.map